import React from 'react';
import Header from './Header';
import Questions from './Questions';

const App = () => {
  return (
    <div>
      <Questions />
    </div>
  );
};

export default App;
